import { getApiBaseUrl } from '@/api/user-portal-service';
import { SsoType } from '@/enums/sso-type';
import type { UserApplication } from '@/types/api.types';

// Split variants launch through their base protocol's IdP-initiated endpoint.
// Mirrors user-portal-api's _DIRECT_LOGIN_KIND_BY_SSO_TYPE.
const SSO_LAUNCH_KIND: Record<SsoType, SsoType.SAML | SsoType.OAUTH> = {
  [SsoType.SAML]: SsoType.SAML,
  [SsoType.SAML_SSK]: SsoType.SAML,
  [SsoType.OAUTH]: SsoType.OAUTH,
  [SsoType.OIDC_SSK]: SsoType.OAUTH,
};

export function buildAppLaunchPath(app: UserApplication): string {
  const ssoPath = SSO_LAUNCH_KIND[app.sso_type as SsoType] ?? SsoType.SAML;

  return `${getApiBaseUrl()}/applications/${app.app_id}/${ssoPath}/direct-login`;
}
